import React, { useState, useEffect } from "react"
import { FormFeedback, Label } from "reactstrap"
import {
  Card,
  Spin,
  Form,
  Button,
  Input,
  Col,
  Select,
  Row,
  Tag,
  Popconfirm,
  Divider,
} from "antd"
import * as Http from "utils/http.helper"
import toastr from "toastr"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import "toastr/build/toastr.min.css"
//Bamboo Wall Decor
import bambooWallDecor from "assets/images/transparent/PRINT/BAMBOO_WALL_DECOR/BAMBOO_WALL_DECOR.png"
//Banner Stand
import bannerStand from "assets/images/transparent/PRINT/BANNER_STAND/BANNER_STAND.png"
//Car visor
import carVisor from "assets/images/transparent/PRINT/CAR_VISOR/CAR_VISOR.png"
// golf Towel
import golfTowel from "assets/images/transparent/PRINT/GOLF_TOWEL/GOLF_TOWEL.png"
// hanging canvas
import hangingCanvas from "assets/images/transparent/PRINT/HANGING_CANVAS/HANGING_CANVAS.png"

// Banner
import banner from "assets/images/transparent/PRINT/BANNER/BANNER.png"
// cake
import cakeTopper from "assets/images/transparent/PRINT/CAKE_TOPPER/CAKE_TOPPER.png"
//canvas
import canvas from "assets/images/transparent/PRINT/CANVAS/CANVAS.png"
//doormat
import doormat from "assets/images/transparent/PRINT/DOORMAT/DOORMAT.png"
//label
import labelImage from "assets/images/transparent/PRINT/LABEL/LABEL.png"
//mug
import mugBack from "assets/images/transparent/PRINT/MUG/MUG_BACK.png"
import mugFront from "assets/images/transparent/PRINT/MUG/MUG_FRONT.png"
//name flag
import nameFlag from "assets/images/transparent/PRINT/NAME_FLAG/NAME_FLAG.png"
//table runner
import tableRunner from "assets/images/transparent/PRINT/TABLE_RUNNER/TABLE_RUNNER.png"
//photo frame
import photoFrameWhite from "assets/images/transparent/PRINT/PHOTO_FRAME/PHOTO_FRAME_WHITE.png"
//wall hangings
import wallHangings from "assets/images/transparent/PRINT/WALL_HANGINGS/WALL_HANGINGS.png"

//ornament
import ornamentHeart from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_HEART.png"
import ornamentRound from "assets/images/transparent/PRINT/ORNAMENT/ORNAMENT_ROUND.png"

//puzzle
import puzzleHeart from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_HEART.png"
import puzzleRectangle from "assets/images/transparent/PRINT/PUZZLE/PUZZLE_RECTANGLE.png"
//sticker
import ketchupSticker from "assets/images/transparent/PRINT/KETCHUP_STICKER/KETCHUP_STICKER.png"
import nutellaSticker from "assets/images/transparent/PRINT/NUTELLA_STICKER/NUTELLA_STICKER.png"
//trinket
import trinketHeart from "assets/images/transparent/PRINT/TRINKET/TRINKET_HEART.png"
import trinketRound from "assets/images/transparent/PRINT/TRINKET/TRINKET_ROUND.png"
import trinketSquare from "assets/images/transparent/PRINT/TRINKET/TRINKET_SQUARE.png"

//yard sign
import yardSignVertical from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_VERTICAL.png"
import yardSignHorizontal from "assets/images/transparent/PRINT/YARD_SIGN/YARD_SIGN_HORIZONTAL.png"

import ImageComponent from "components/image"
import { DownloadOutlined } from "@ant-design/icons"
import { getEncodedS3Url } from "utils/encodedS3url"
const { TextArea } = Input

const optionGroupFront = [
  {
    value: "front",
    label: "Front View",
  },
]

const optionGroupMug = [
  {
    value: "front",
    label: "Front View",
  },
  {
    value: "back",
    label: "Back View",
  },
]

const optionGroupOrnament = [
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "round",
    label: "Round View",
  },
]

const optionGroupPuzzle = [
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "rectangle",
    label: "Rectangle View",
  },
]

const optionGroupTrinket = [
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "round",
    label: "Round View",
  },
  {
    value: "square",
    label: "Square View",
  },
]

const optionGroupYardSign = [
  {
    value: "vertical",
    label: "Vertical View",
  },
  {
    value: "horizontal",
    label: "Horizontal View",
  },
]

const optionGroupSweat = [
  {
    value: "front",
    label: "Front View",
  },
  {
    value: "back",
    label: "Back View",
  },
  {
    value: "vertical",
    label: "Vertical View",
  },
  {
    value: "heart",
    label: "Heart View",
  },
  {
    value: "round",
    label: "Round View",
  },
  {
    value: "square",
    label: "Square View",
  },
  {
    value: "horizontal",
    label: "Horizontal View",
  },
  {
    value: "ketchup",
    label: "Ketchup View",
  },
  {
    value: "nutella",
    label: "Nutella View",
  },
  {
    value: "rectangle",
    label: "Rectangle View",
  },
]
const imageValue = [
  {
    position: "front",
    img: 0,
  },
  {
    position: "back",
    img: 0,
  },
  {
    position: "heart",
    img: 0,
  },
  {
    position: "rectangle",
    img: 0,
  },
  {
    position: "ketchup",
    img: 0,
  },
  {
    position: "nutella",
    img: 0,
  },
  {
    position: "round",
    img: 0,
  },
  {
    position: "square",
    img: 0,
  },
  {
    position: "vertical",
    img: 0,
  },
  {
    position: "horizontal",
    img: 0,
  },
]

const MultiplePrintDesignUpload = () => {
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state
  const [selectedFiles, setselectedFiles] = useState([])
  const [color, setColor] = useState(null)
  const [controlArea, setControlArea] = useState(true)
  const [selectedMulti, setselectedMulti] = useState([])
  const [erroList, setErroList] = useState([])
  const [style, setStyle] = useState(null)
  const [options, setOptions] = useState({ sizes: [], colors: [], styles: [] })
  const [registeredPositions, setRegisterePositions] = useState([])
  const [loading, setLoading] = useState(false)
  const [boxLoading, setBoxLoading] = useState(false)
  const [orderInfo, setOrderInfo] = useState([])

  useEffect(() => {
    if (style) {
      if (
        style?.label === "Banner" ||
        style?.label === "Cake Topper" ||
        style?.label === "Canvas" ||
        style?.label === "Doormat" ||
        style?.label === "Label" ||
        style?.label === "Frame" ||
        style?.label === "Wall Hangings" ||
        style?.label === "Wall Sign" ||
        style?.label === "Car Visor" ||
        style?.label === "Bamboo Wall Decor" ||
        style?.label === "Table Runner" ||
        style?.label === "Ketchup Sticker" ||
        style?.label === "Nutella Sticker" ||
        style?.label === "Hanging Canvas" ||
        style?.label === "Banner Stand" ||
        style?.label === "Golf Towel" ||
        style?.label === "Name Flag" ||
        style?.label === "Tent Banner"
      ) {
        setControlArea(
          optionGroupFront.filter(x => !registeredPositions.includes(x.value))
            .length > 0
        )
      } else if (style?.label === "Ornament") {
        setControlArea(
          optionGroupOrnament.filter(
            x => !registeredPositions.includes(x.value)
          ).length > 0
        )
      } else if (style?.label === "Mug") {
        setControlArea(
          optionGroupMug.filter(x => !registeredPositions.includes(x.value))
            .length > 0
        )
      } else if (style?.label === "Puzzle") {
        setControlArea(
          optionGroupPuzzle.filter(x => !registeredPositions.includes(x.value))
            .length > 0
        )
      } else if (style?.label === "Trinket Dish") {
        setControlArea(
          optionGroupTrinket.filter(x => !registeredPositions.includes(x.value))
            .length > 0
        )
      } else if (style?.label === "Yard Sign") {
        setControlArea(
          optionGroupYardSign.filter(
            x => !registeredPositions.includes(x.value)
          ).length > 0
        )
      } else {
        setControlArea(
          optionGroupFront.filter(x => !registeredPositions.includes(x.value))
            .length > 0
        )
      }
    }
  }, [style, registeredPositions])

  const getOptions = () => {
    setLoading(true)
    Http.get(`api/orders/GetPrintProperties`)
      .then(res => {
        if (res?.success) {
          setLoading(false)
          setOptions({
            sizes: [
              {
                label: "Size",
                options: res.data.sizes.map(item => {
                  return { label: item.name, value: item.id }
                }),
              },
            ],
            colors: [
              {
                label: "Color",
                options: res.data.colors.map(item => {
                  return {
                    label: item.name + " (" + item.hexCode + ")",
                    value: item.id,
                    hexCode: item.hexCode,
                  }
                }),
              },
            ],
            styles: [
              {
                label: "Styles",
                options: res.data.styles.map(item => {
                  return {
                    label: item.name,
                    value: item.id,
                  }
                }),
              },
            ],
          })
        }
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error.response.data.Message)
      })
  }

  useEffect(() => {
    getOptions()
  }, [])

  const getImages = () => {
    setLoading(true)
    Http.get(
      `api/orders/GetPrintOrderImages?Sku=${state?.sku}&Id=${
        state?.id
      }&OrderId=${String(state?.orderId)}&sizeId=${state?.sizeId}`
    )
      .then(res => {
        if (res?.success) {
          setRegisterePositions(
            res.data.map(item => {
              return item.positionCode
            })
          )
          if (res?.data?.length > 0) {
            setOrderInfo(res.data)
          }

          setLoading(false)
        }
      })
      .catch(function (error) {
        setLoading(false)
      })
  }
  useEffect(() => {
    getImages()
  }, [state])
  useEffect(() => {
    if (
      options.sizes.length > 0 &&
      options.colors.length > 0 &&
      options.styles.length > 0 &&
      state?.styleId &&
      state?.sizeId
      // && state?.colorId
    ) {
      console.log(state?.styleId, state?.sizeId, state?.colorId)
      const findSize = options.sizes[0].options.find(
        x => x.value === parseInt(state?.sizeId)
      )
      const findColor = options.colors[0].options.find(
        x => x.value === parseInt(state?.colorId)
      )
      const findStyle = options.styles[0].options.find(
        x => x.value === parseInt(state?.styleId)
      )
      setStyle(findStyle)
      setColor(findColor)
      form.setFieldsValue({
        price: parseFloat(state?.price) + " $",
        size: findSize?.label,
        type: findStyle?.label,
        color: findColor?.label,
        notes: state?.note,
      })
    }
  }, [state?.styleId, state?.sizeId, state?.colorId, options])

  const handleAcceptedFiles = (files, position) => {
    setLoading(true)
    const arr = []
    if (files.length > 0) {
      ;[...files].map(item => {
        item.url = URL.createObjectURL(item)
      })

      selectedFiles.length > 0 &&
        selectedFiles.map((item, index) => {
          item.position !== position
            ? arr.push({
                position: item.position,
                images: [...item.images],
              })
            : delete item[index]
        })
      arr.push({
        position: position,
        images: [...files],
      })
    }
    setselectedFiles(arr)

    setLoading(false)
  }
  const downloadImage = async imageUrl => {
    const newWindow = window.open(imageUrl, "_blank")
    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      alert("Pop-up engellendi. Lütfen tarayıcı ayarlarını kontrol edin.")
    }
  }

  const handleSave = () => {
    setLoading(true)
    const formValues = form.getFieldsValue()
    const error = []
    if (selectedMulti.length === 0) {
      error.push("position")
    }
    if (selectedFiles.length === 0) {
      error.push("icon")
    }
    setErroList(error)
    if (error.length === 0) {
      const formData = new FormData()
      formData.append("sku", state?.sku)
      formData.append("id", state?.id)
      formData.append("orderId", state?.orderId)
      formData.append("hasPersonalization", state?.hasPersonalization)
      formData.append("Note", formValues.notes ? formValues.notes : "")
      formData.append(
        "IsWaitingForDesign",
        state?.waitingList ? state.waitingList : false
      )

      selectedFiles.map((item, index) => {
        formData.append(`imageModels[${index}].positionCode`, item.position)

        item.images.map((x, i) => {
          formData.append(`imageModels[${index}].images`, x)
        })
      })

      Http.post_form_data("api/orders/UploadPrintImageToOrder", formData)
        .then(res => {
          if (res.success) {
            toastr.success(
              `Image upload for sku number ${state?.sku} was successful.`
            )
            setTimeout(() => {
              toastr.info("Listeye yönlendiriliyorsunuz. Lütfen bekleyiniz.")
              setTimeout(() => {
                setLoading(false)
                navigate(
                  state?.waitingList
                    ? "/waiting-for-desing-print"
                    : "/multiple-order-list"
                )
              }, 500)
            }, 500)
          } else {
            setLoading(false)
            toastr.error(res?.Message)
          }
        })
        .catch(function (error) {
          setLoading(false)
          toastr.error(error?.response.data.Message)
        })
    } else {
      setLoading(false)
    }
  }
  const css = `
  .image_card_p0{
    padding:0!important
  }

  .image_card_p0 .ant-card-body{
    padding:0!important
  }

  .front{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .heart{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .rectangle{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .back{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }


  .rectangle{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .ketchup{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .nutella{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .round{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .square{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .vertical{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }

  .horizontal{
    position:absolute;
    top:29%;
    left:29%;
    z-index:1;
    width:150px;
    height:150px;
    ${
      color?.hexCode === "#fff" ||
      color?.hexCode === "#ffffff" ||
      color?.hexCode === "#000" ||
      color?.hexCode === "#000000"
        ? "background-color:#e8e8e8ad"
        : ""
    }
  }




  }`

  const onDelete = positionCode => {
    setLoading(true)
    let obj = {
      sku: state?.sku,
      orderId: state?.id,
      positions: [
        {
          positionCode: positionCode,
        },
      ],
    }
    Http.post(`api/orders/removePrintImages`, obj)
      .then(res => {
        if (res?.success) {
          setRegisterePositions([])
          setLoading(false)
          getImages()
          toastr.success(`Process Success.`)

          let newPrice = parseFloat(state?.price) - 1

          form.setFieldsValue({
            price: parseFloat(state?.price) + " $",
          })
        } else {
          setLoading(false)
          toastr.error(res?.Message)
        }
      })
      .catch(function (error) {
        setLoading(false)
        toastr.error(error?.response?.data?.Message)
      })
  }
  return (
    <React.Fragment>
      <style>{css}</style>
      <Spin spinning={loading}>
        <div className="page-content">
          <Breadcrumbs
            title={
              <>
                Print Design Upload Page{" "}
                <span style={{ fontSize: 14 }}>
                  <span style={{ opacity: "0.3" }}>[ Order: </span>
                  {state?.orderId}{" "}
                  <span style={{ opacity: "0.3" }}>| Sku: </span>
                  {state?.sku}
                  <span style={{ opacity: "0.3" }}> ]</span>
                </span>
              </>
            }
          />
          <Card className="mt-3 mb-3">
            <style>{css}</style>
            {registeredPositions.length > 0 && (
              <>
                <Divider orientation="left">Registered positions: </Divider>
                <Row gutter={[16, 16]}>
                  {console.log(registeredPositions, "registeredPositions")}
                  {registeredPositions.map((item, index) => {
                    return (
                      <Col lg={6} key={item}>
                        <Tag
                          color="volcano"
                          style={{
                            color: "black",
                            padding: "5px 8px",
                            fontSize: "15px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {console.log(optionGroupSweat, "optionGroupSweat")}
                          <span>
                            {index + 1} -{" "}
                            {optionGroupSweat.find(x => x.value === item).label}
                          </span>

                          <Popconfirm
                            title="Attention!"
                            description={
                              <>
                                Are you sure you want to delete the design for
                                the <br />
                                <span style={{ fontWeight: "700" }}>
                                  {
                                    optionGroupSweat.find(x => x.value === item)
                                      .label
                                  }
                                </span>{" "}
                                of the Order?
                              </>
                            }
                            onConfirm={() => {
                              onDelete(
                                optionGroupSweat.find(x => x.value === item)
                                  .value
                              )
                            }}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button
                              danger
                              icon={<i className="mdi mdi-delete" />}
                            />
                          </Popconfirm>
                        </Tag>
                        {console.log(orderInfo, "orderInfo")}
                        {orderInfo.length > 0 && (
                          <>
                            {orderInfo
                              .filter(x => x.positionCode === item)
                              .map((item, index) => {
                                let imageUrl = null
                                if (item.positionCode === "front") {
                                  imageUrl =
                                    style?.label === "Banner"
                                      ? banner
                                      : style?.label === "Tent Banner"
                                      ? banner
                                      : style?.label === "Cake Topper"
                                      ? cakeTopper
                                      : style?.label === "Canvas"
                                      ? canvas
                                      : style?.label === "Doormat"
                                      ? doormat
                                      : style?.label === "Label"
                                      ? labelImage
                                      : style?.label === "Frame"
                                      ? photoFrameWhite
                                      : style?.label === "Wall Hangings"
                                      ? wallHangings
                                      : style?.label === "Car Visor"
                                      ? carVisor
                                      : style?.label === "Bamboo Wall Decor"
                                      ? bambooWallDecor
                                      : style?.label === "Table Runner"
                                      ? tableRunner
                                      : style?.label === "Ketchup Sticker"
                                      ? ketchupSticker
                                      : style?.label === "Nutella Sticker"
                                      ? nutellaSticker
                                      : style?.label === "Hanging Canvas"
                                      ? hangingCanvas
                                      : style?.label === "Banner Stand"
                                      ? bannerStand
                                      : style?.label === "Golf Towel"
                                      ? golfTowel
                                      : style?.label === "Name Flag"
                                      ? nameFlag
                                      : style?.label === "Mug"
                                      ? mugFront
                                      : doormat // Default image
                                } else if (item.positionCode === "heart") {
                                  imageUrl =
                                    style?.label === "Ornament"
                                      ? ornamentHeart
                                      : style?.label === "Puzzle"
                                      ? puzzleHeart
                                      : style?.label === "Trinket Dish"
                                      ? trinketHeart
                                      : doormat // Default image
                                } else if (item.positionCode === "back") {
                                  imageUrl =
                                    style?.label === "Mug" ? mugBack : doormat // Default image
                                } else if (item.positionCode === "round") {
                                  imageUrl =
                                    style?.label === "Ornament"
                                      ? ornamentRound
                                      : style?.label === "Trinket Dish"
                                      ? trinketRound
                                      : doormat // Default image
                                } else if (item.positionCode === "rectangle") {
                                  imageUrl =
                                    style?.label === "Puzzle"
                                      ? puzzleRectangle
                                      : doormat // Default image
                                } else if (item.positionCode === "square") {
                                  imageUrl =
                                    style?.label === "Trinket Dish"
                                      ? trinketSquare
                                      : doormat // Default image
                                } else if (item.positionCode === "vertical") {
                                  imageUrl =
                                    style?.label === "Yard Sign"
                                      ? yardSignVertical
                                      : doormat // Default image
                                } else if (item.positionCode === "horizontal") {
                                  imageUrl =
                                    style?.label === "Yard Sign"
                                      ? yardSignHorizontal
                                      : doormat // Default image
                                }
                                return (
                                  <>
                                    <Card
                                      hoverable
                                      key={index + "-file"}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        justifyContent: "center",
                                      }}
                                      className="image_card_p0 mb-3"
                                    >
                                      <Spin spinning={boxLoading}>
                                        <div
                                          style={{ background: color?.hexCode }}
                                        >
                                          <ImageComponent
                                            key={`tshirt_${index}]`}
                                            imageUrl={imageUrl}
                                            width={350}
                                            height={350}
                                            preview={false}
                                          />
                                        </div>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginTop: "10px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                            color: "black",
                                          }}
                                        >
                                          <Button
                                            type="primary"
                                            icon={<DownloadOutlined />}
                                            onClick={() =>
                                              downloadImage(item?.imageUrl?.[0])
                                            }
                                          >
                                            Download
                                          </Button>
                                        </div>
                                        {orderInfo && (
                                          <div
                                            className={
                                              item.positionCode +
                                              " " +
                                              style?.label?.toLowerCase() +
                                              " designPrint"
                                            }
                                            key={`div_${index}]`}
                                            style={{
                                              backgroundImage: `url(${getEncodedS3Url(
                                                item?.imageUrl?.[0]
                                              )})`,
                                              border: "red 1px dashed",
                                              backgroundSize: "contain",
                                              backgroundRepeat: "no-repeat",
                                              backgroundPosition: "bottom",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                          />
                                        )}
                                      </Spin>
                                    </Card>
                                  </>
                                )
                              })}
                          </>
                        )}
                      </Col>
                    )
                  })}
                </Row>
                <Divider />
              </>
            )}
            {controlArea ? (
              <Form form={form} layout="vertical">
                <Row gutter={[16, 0]}>
                  <Col lg={16}>
                    <Row gutter={[16, 0]}>
                      <Col lg={6}>
                        <Form.Item
                          label="Type"
                          name="type"
                          rules={[
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col lg={6}>
                        <Form.Item
                          label="Size"
                          name="size"
                          rules={[
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col lg={6}>
                        <Form.Item
                          label="Color"
                          name="color"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "This field is required!",
                          //   },
                          // ]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                      <Col lg={6}>
                        <Form.Item
                          label="Price"
                          name="price"
                          rules={[
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ]}
                        >
                          <Input disabled />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[16, 0]}>
                      <Col lg={24}>
                        <Form.Item
                          label="Icon Position"
                          name="position"
                          rules={[
                            {
                              required: true,
                              message: "This field is required!",
                            },
                          ]}
                        >
                          <Select
                            defaultValue={selectedMulti}
                            mode="tags"
                            tokenSeparators={[","]}
                            onChange={e => {
                              setBoxLoading(true)
                              setTimeout(() => {
                                setBoxLoading(false)
                              }, 750)
                              let newPrice = 0
                              if (registeredPositions.length > 0) {
                                newPrice =
                                  parseFloat(state?.price) + parseInt(e.length)
                              } else {
                                newPrice =
                                  parseFloat(state?.price) +
                                  parseInt(e.length - 1)
                              }
                              form.setFieldsValue({
                                price: parseFloat(state?.price) + " $",
                              })
                              setErroList([])
                              setselectedMulti(e)
                            }}
                            options={
                              style?.label === "Banner" ||
                              style?.label === "Cake Topper" ||
                              style?.label === "Canvas" ||
                              style?.label === "Doormat" ||
                              style?.label === "Label" ||
                              style?.label === "Frame" ||
                              style?.label === "Wall Hangings" ||
                              style?.label === "Wall Sign" ||
                              style?.label === "Car Visor" ||
                              style?.label === "Bamboo Wall Decor" ||
                              style?.label === "Table Runner" ||
                              style?.label === "Ketchup Sticker" ||
                              style?.label === "Nutella Sticker" ||
                              style?.label === "Hanging Canvas" ||
                              style?.label === "Banner Stand" ||
                              style?.label === "Golf Towel" ||
                              style?.label === "Name Flag" ||
                              style?.label === "Tent Banner"
                                ? registeredPositions.length > 0
                                  ? optionGroupFront.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupFront
                                : style?.label === "Ornament"
                                ? registeredPositions.length > 0
                                  ? optionGroupOrnament.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupOrnament
                                : style?.label === "Mug"
                                ? registeredPositions.length > 0
                                  ? optionGroupMug.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupMug
                                : style?.label === "Puzzle"
                                ? registeredPositions.length > 0
                                  ? optionGroupPuzzle.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupPuzzle
                                : style?.label === "Trinket Dish"
                                ? registeredPositions.length > 0
                                  ? optionGroupTrinket.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupTrinket
                                : style?.label === "Yard Sign"
                                ? registeredPositions.length > 0
                                  ? optionGroupYardSign.filter(
                                      x =>
                                        !registeredPositions.includes(x.value)
                                    )
                                  : optionGroupYardSign
                                : registeredPositions.length > 0
                                ? optionGroupFront.filter(
                                    x => !registeredPositions.includes(x.value)
                                  )
                                : optionGroupFront
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={8}>
                    <Row gutter={[16, 0]}>
                      <Col lg={24}>
                        <Form.Item
                          name="notes"
                          label="Notes"
                          style={{ width: "100%" }}
                        >
                          <TextArea
                            rows={5}
                            disabled={state?.note && state?.note.length > 0}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>{" "}
              </Form>
            ) : (
              <Tag
                color="volcano"
                style={{
                  width: "100%",
                  padding: "10px 15px",
                  textAlign: "center",
                }}
              >
                <span
                  style={{
                    color: "red",
                    fontWeight: "bold",
                    fontSize: 15,
                  }}
                >
                  Tüm Pozisyonlar için tasarım yükleme işlemi gerçekleştirilmiş.
                  Eğer yükleme yapmak istiyorsanız önce yükleme yaapcağınız
                  posizyon için silme işlemi gerçekleştiriniz.
                </span>
              </Tag>
            )}
          </Card>
          {console.log(selectedMulti, "selectedMulti")}
          {selectedMulti.length > 0 && (
            <Row gutter={[16, 0]}>
              {selectedMulti.map((item, index) => {
                const findValue = selectedFiles?.find(x => x.position === item)
                const findText = optionGroupSweat?.find(x => x.value === item)
                const val = imageValue.find(x => x.position === item)
                let imageUrl = null
                if (item === "front") {
                  imageUrl =
                    style?.label === "Banner"
                      ? banner
                      : style?.label === "Tent Banner"
                      ? banner
                      : style?.label === "Cake Topper"
                      ? cakeTopper
                      : style?.label === "Canvas"
                      ? canvas
                      : style?.label === "Doormat"
                      ? doormat
                      : style?.label === "Label"
                      ? labelImage
                      : style?.label === "Frame"
                      ? photoFrameWhite
                      : style?.label === "Wall Hangings"
                      ? wallHangings
                      : style?.label === "Car Visor"
                      ? carVisor
                      : style?.label === "Bamboo Wall Decor"
                      ? bambooWallDecor
                      : style?.label === "Table Runner"
                      ? tableRunner
                      : style?.label === "Ketchup Sticker"
                      ? ketchupSticker
                      : style?.label === "Nutella Sticker"
                      ? nutellaSticker
                      : style?.label === "Hanging Canvas"
                      ? hangingCanvas
                      : style?.label === "Banner Stand"
                      ? bannerStand
                      : style?.label === "Golf Towel"
                      ? golfTowel
                      : style?.label === "Name Flag"
                      ? nameFlag
                      : style?.label === "Mug"
                      ? mugFront
                      : doormat // Default image
                } else if (item === "heart") {
                  imageUrl =
                    style?.label === "Ornament"
                      ? ornamentHeart
                      : style?.label === "Puzzle"
                      ? puzzleHeart
                      : style?.label === "Trinket Dish"
                      ? trinketHeart
                      : doormat // Default image
                } else if (item === "back") {
                  imageUrl = style?.label === "Mug" ? mugBack : doormat // Default image
                } else if (item === "round") {
                  imageUrl =
                    style?.label === "Ornament"
                      ? ornamentRound
                      : style?.label === "Trinket Dish"
                      ? trinketRound
                      : doormat // Default image
                } else if (item === "rectangle") {
                  imageUrl =
                    style?.label === "Puzzle" ? puzzleRectangle : doormat // Default image
                } else if (item === "square") {
                  imageUrl =
                    style?.label === "Trinket Dish" ? trinketSquare : doormat // Default image
                } else if (item === "vertical") {
                  imageUrl =
                    style?.label === "Yard Sign" ? yardSignVertical : doormat // Default image
                } else if (item === "horizontal") {
                  imageUrl =
                    style?.label === "Yard Sign" ? yardSignHorizontal : doormat // Default image
                }
                return (
                  <Col lg={6} key={index + "-col"}>
                    <Card
                      hoverable
                      key={index + "-file"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "10px",
                        justifyContent: "center",
                      }}
                      className="image_card_p0 mb-3"
                    >
                      <Spin spinning={boxLoading}>
                        <div style={{ background: color?.hexCode }}>
                          <ImageComponent
                            key={`tshirt_${index}]`}
                            imageUrl={imageUrl}
                            width={350}
                            height={350}
                            preview={false}
                          />
                        </div>

                        {selectedMulti && selectedFiles.length > 0 && (
                          <div
                            className={
                              item +
                              " " +
                              style.label.toLowerCase() +
                              " designPrint"
                            }
                            key={`div_${index}]`}
                            style={{
                              backgroundImage: `url(${getEncodedS3Url(
                                findValue?.images[val?.img]?.url
                              )})`,
                              border: "red 1px dashed",
                              backgroundSize: "contain",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "bottom",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          />
                          //   <div
                          //   className={
                          //     item +
                          //     " " +
                          //     style.label.toLowerCase() +
                          //     " designPrint"
                          //   }
                          //   key={`div_${index}]`}
                          //   style={{
                          //     position: "absolute",
                          //     top: "50%",
                          //     left: "50%",
                          //     transform: "translate(-50%, -50%) scale(1.8)", // ORTALA + BÜYÜT
                          //     transformOrigin: "center",
                          //     width: "150px",
                          //     height: "130px",
                          //     backgroundImage: `url(${findValue?.images[val?.img]?.url})`,
                          //     backgroundSize: "cover",
                          //     backgroundPosition: "center",
                          //     border: "2px dashed red",
                          //     clipPath:
                          //       'path("M75 130 C 30 100, 0 60, 38 30 A 25 25 0 0 1 75 50 A 25 25 0 0 1 112 30 C 150 60, 120 100, 75 130 Z")',
                          //   }}
                          // />
                        )}
                      </Spin>
                      <div className="mb-3" style={{ width: "100%" }}>
                        <Label
                          className="form-label mt-1"
                          style={{ fontWeight: 600 }}
                        >
                          {findText?.label} - Icon
                        </Label>
                        <input
                          type="file"
                          accept="image/*,application/pdf"
                          className="form-control"
                          onChange={e => {
                            setErroList([])
                            handleAcceptedFiles(e.target.files, item)
                          }}
                        />
                        <FormFeedback
                          type="valid"
                          style={
                            erroList.find(x => x === "icon")
                              ? { display: "block" }
                              : {}
                          }
                        >
                          This field is required.
                        </FormFeedback>
                      </div>
                    </Card>
                  </Col>
                )
              })}
            </Row>
          )}
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                columnGap: 15,
                padding: 12,
                background: "white",
                marginBottom: 15,
                borderRadius: 15,
              }}
            >
              <Button
                type="button"
                className="btn btn_default d-flex align-items-center justify-content-center"
                onClick={() => {
                  navigate(
                    state?.waitingList
                      ? "/waiting-for-desing-print"
                      : "/multiple-order-list"
                  )
                }}
                icon={
                  <i className="bx bx-arrow-back font-size-16 align-middle mr-2"></i>
                }
              >
                Return to List
              </Button>
              <Button
                type="button"
                className="btn btn-primary d-flex align-items-center justify-content-center mt-1"
                style={{ maxWidth: 100 }}
                onClick={() => {
                  setLoading(true)
                  setTimeout(() => {
                    form
                      .validateFields()
                      .then(() => {
                        handleSave()
                      })
                      .catch(err => {
                        setLoading(false)
                      })
                  }, 300)
                }}
              >
                {" "}
                Design Save
              </Button>
            </Col>
          </Row>
        </div>
      </Spin>
    </React.Fragment>
  )
}

export default MultiplePrintDesignUpload
